import { helpDialog } from "@features/session/constants";
import { useDevice } from "@hooks/useDevice";
import type { BaseItemSchema } from "@memorang/types";
import { ConfirmDialog } from "@memorang/ui/components/ConfirmDialog";
import { Redirect, useRouter } from "expo-router";
import type { Dispatch, SetStateAction } from "react";

type Props = {
	helpDialogVisible: boolean;
	sessionItems: BaseItemSchema[];
	numericId: number;
	totalTime: number;
	examName?: string;
	setHelpDialogVisible: Dispatch<SetStateAction<boolean>>;
	numSections: number;
	numTotalQuestions: number;
};

const SessionHelpDialog = ({
	helpDialogVisible,
	sessionItems,
	examName,
	totalTime,
	numericId,
	setHelpDialogVisible,
	numSections,
	numTotalQuestions,
}: Props) => {
	const router = useRouter();

	const { isMobile } = useDevice();

	if (helpDialogVisible) {
		const currentSessionItems = sessionItems;
		const confirmDialogConfig = helpDialog({
			sessionItems: currentSessionItems,
			numSections,
			examName: examName!,
			totalTime,
			isDiagnosticTest: false,
			numTotalQuestions,
		});

		if (isMobile) {
			return (
				<Redirect
					href={`/info?title=${confirmDialogConfig.title}&body=${confirmDialogConfig.body}`}
				/>
			);
		}

		return (
			<ConfirmDialog
				visible={helpDialogVisible}
				title={confirmDialogConfig.title}
				icon={confirmDialogConfig.icon}
				body={confirmDialogConfig.body}
				confirmCallback={() => {
					setHelpDialogVisible(false);
					router.replace({
						pathname: "/(protected)/session/[id]",
						params: {
							id: numericId,
							index: "1",
						},
					});
				}}
				confirmCta="Got it"
			/>
		);
	}
	return null;
};

export default SessionHelpDialog;
